import { Button, Popup } from "@garther/ui/components";
import { useI18n } from "@garther/ui/libs";

import { useRemoveOrgMember } from "@/features/org/hooks/use-org-query";

interface RemoveTarget {
  userId: string;
  name: string;
}

interface OrgMemberRemoveModalProps {
  orgId: string;
  member: RemoveTarget | null;
  onClose: () => void;
}

export function OrgMemberRemoveModal({ orgId, member, onClose }: OrgMemberRemoveModalProps) {
  const { t } = useI18n();

  const { mutate: removeMember, isPending: isRemoving } = useRemoveOrgMember({
    onSuccess: onClose
  });

  const handleRemove = () => {
    if (!member || isRemoving) return;
    removeMember({ orgId, userId: member.userId });
  };

  return (
    <Popup isOpen={!!member} onClose={onClose}>
      <div className="space-y-6">
        <div>
          <h2 className="text-responsive-lg font-semibold text-text-primary">
            {t("org.members.removeModal.title")}
          </h2>
          <p className="text-responsive-base text-text-secondary mt-1">
            {t("org.members.removeModal.description", {
              name: member?.name ?? ""
            })}
          </p>
        </div>

        <div className="flex justify-end space-x-3">
          <Button variant="outline" onClick={onClose} disabled={isRemoving}>
            {t("common.cancel")}
          </Button>
          <Button
            onClick={handleRemove}
            disabled={isRemoving}
            className="bg-red-500 hover:bg-red-600 text-white"
          >
            {isRemoving ? t("org.members.removeModal.removing") : t("org.members.removeModal.confirm")}
          </Button>
        </div>
      </div>
    </Popup>
  );
}
